/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M8 0a8 8 0 1 0 7.61 10.5v-.13A8 8 0 0 0 7.96.04Zm1.66 1.19-.71 2.69a3.82 3.82 0 0 0-1-.13 3.63 3.63 0 0 0-.87.1l-.69-2.69a6.74 6.74 0 0 1 3.27.03ZM11.26 8A3.26 3.26 0 1 1 8 4.73 3.25 3.25 0 0 1 11.26 8ZM5.49 1.5l.7 2.7a4.22 4.22 0 0 0-2 2L1.5 5.47A7 7 0 0 1 5.49 1.5ZM.99 8.04a7.3 7.3 0 0 1 .19-1.61l2.68.72a3.86 3.86 0 0 0 0 1.82l-2.67.74a6.76 6.76 0 0 1-.21-1.67Zm4.49 6.54a7 7 0 0 1-4-3.93l2.7-.75a4.22 4.22 0 0 0 2 2Zm.94.28.72-2.67a3.7 3.7 0 0 0 1.81 0l.72 2.68a6.74 6.74 0 0 1-3.25-.05Zm4.19-.32-.73-2.71a4.24 4.24 0 0 0 1.94-2l2.69.75a7 7 0 0 1-3.9 3.92Zm4.41-6.5a7.52 7.52 0 0 1-.21 1.64l-2.62-.78a4 4 0 0 0 .11-.9 4.81 4.81 0 0 0-.1-.85l2.67-.74a7.06 7.06 0 0 1 .2 1.59Zm-3.17-1.79a4.23 4.23 0 0 0-2-2l.71-2.71a7 7 0 0 1 3.93 4Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'LifePreserverIcon';

export default Icon;
